module.exports = __webpack_public_path__ + "img/to_kf.a1979a96.svg";